import {EmailIcon, PhoneIcon} from "@chakra-ui/icons";
import {Box, Flex, Text, VStack} from "@chakra-ui/react";
import React from "react";
import {matchRoutes, useLocation} from "react-router-dom";

import {Paths} from "../shared/model/Constants";

const Footer = () => {
  const { pathname } = useLocation();
  return (
    <>{ !matchRoutes([{path:Paths.TESTS_PUBLIC_ID}], pathname) &&
      !matchRoutes([{path:Paths.SPEECH_TEST}], pathname) &&
      !matchRoutes([{path:Paths.AUTOMATED_TEST}], pathname) &&
      <>
        <Box bg="#FDB912" height="1em"/>
        <Flex justify="space-evenly" align="center" bg="#403F3F" paddingBlock="1.5em">
          <VStack color="white" alignItems="start">
            <Text as='b' paddingBottom="1em" paddingLeft="1.5em" fontSize='lg'>PELEx</Text>
            <Text><PhoneIcon /> &nbsp;2511-8448</Text>
            <Text><EmailIcon color="white"/> &nbsp;exameningles.elm@ucr.ac.cr</Text>
            <Text><PhoneIcon color="white"/> &nbsp;2511-8448, 2511-3630, 2511-7288</Text>
          </VStack>
          <VStack color="white" alignItems="start">
            <Text as='b' paddingBottom="1em" paddingLeft="1.5em" fontSize='lg'>Language Inc.</Text>
            <Text><PhoneIcon color="white"/> &nbsp;8396-6679</Text>
            <Text><EmailIcon color="white"/> &nbsp;advisors@languageincr.com</Text>
            <Text><PhoneIcon color="white"/> &nbsp;8396-6679</Text>
          </VStack>
        </Flex>

      </>}
    </>
  );
};

export default Footer;
